import { createCustomSwiper, createSwiperProductBlocks } from '../base.js'
import { addHpBlog } from '../blog/blog.js'

function createCarousel() {
    const carousel = document.querySelector('#carousel')

    if (!carousel) return

    createCustomSwiper('#carousel .carousel-inner', {
        swiperClass: 'hp-carousel',
        pagination: true,
        arrows: false,
        customOptions: {
            loop: true,
        },
    })
}

function createCategoriesSwiper() {

    new Swiper('.swiper-categories', {
        slidesPerView: 1.2,
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 4.3,
            },
            1199: {
                slidesPerView: 7,
            },
        },
    })
}

function addProductsGroupBtn() {
    const groupTitles = document.querySelectorAll('.homepage-group-title')

    groupTitles.forEach((group) => {
        const [title, url, btnText] = group.innerText.split(';')

        if (url) {
            const buttonHTML = /* HTML */ `
                <div class="text-center group-btn-margin">
                    <a href="${url.trim()}" class="btn btn-secondary group-products-btn">
                        ${btnText ? btnText : 'Zobrazit více'}
                    </a>
                </div>
            `
            group.nextElementSibling.nextElementSibling
                .querySelector('.swiper-navigation')
                .insertAdjacentHTML('afterend', buttonHTML)

            group.innerText = title.trim()
        }
    })
}

export function initHomepage() {
    createCarousel()
    createCategoriesSwiper()
    createSwiperProductBlocks()
}
